import React, { useState, useEffect } from "react";

const FormEditSchedule = ({ selectedTarget, handleEdit }) => {
  const [formData, setFormData] = useState({
    production_target: "",
    delivery_target: "",
    end_time: "",
  });

  const [errors, setErrors] = useState({});

  // Cargar los datos cuando se selecciona un target
  useEffect(() => {
    if (selectedTarget) {
      setFormData({
        production_target: selectedTarget.production_target || "",
        delivery_target: selectedTarget.delivery_target || "",
        end_time: formatTime(selectedTarget.end_time) || "",
      });
      setErrors({});
    }
  }, [selectedTarget]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Limpiar error del campo cuando el usuario empiece a escribir
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.production_target || formData.production_target < 0) {
      newErrors.production_target = "La meta de producción debe ser mayor a 0";
    }

    if (!formData.delivery_target || formData.delivery_target < 0) {
      newErrors.delivery_target = "La meta de delivery debe ser mayor a 0";
    }

    if (!formData.end_time) {
      newErrors.end_time = "La hora es obligatoria";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (validateForm()) {
      const updatedData = {
        ...selectedTarget,
        production_target: parseInt(formData.production_target),
        delivery_target: parseInt(formData.delivery_target),
        end_time: formData.end_time, // Ya viene en formato HH:MM del input type="time"
      };

      handleEdit(updatedData);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date.toLocaleDateString("es-ES", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const formatTime = (timeString) => {
    if (!timeString) return "";
    return timeString.slice(0, 5); // Formato HH:MM
  };

  if (!selectedTarget) {
    return (
      <div className="text-center p-4">
        <p className="text-muted">No hay datos para mostrar</p>
      </div>
    );
  }

  return (
    <div className="container-fluid p-0">
      <form onSubmit={handleSubmit}>
        <div className="row">
          {/* Campos de solo lectura */}
          <div className="col-12 col-md-6 mb-3 d-none">
            <label htmlFor="id" className="form-label fw-bold">
              ID
            </label>
            <input
              type="text"
              id="id"
              className="form-control-plaintext bg-light border rounded px-3 py-2"
              value={selectedTarget.id || ""}
              readOnly
            />
          </div>

          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="production_date" className="form-label fw-bold">
              Fecha
            </label>
            <input
              type="text"
              id="production_date"
              className="form-control-plaintext bg-light border rounded px-3 py-2"
              value={formatDate(selectedTarget.production_date)}
              readOnly
            />
          </div>

          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="end_time" className="form-label fw-bold">
              Hora <span className="text-danger">*</span>
            </label>
            <input
              type="time"
              id="end_time"
              name="end_time"
              className={`form-control ${
                errors.end_time ? "is-invalid" : ""
              }`}
              value={formData.end_time}
              onChange={handleInputChange}
              placeholder="Seleccione la hora"
            />
            {errors.end_time && (
              <div className="invalid-feedback">{errors.end_time}</div>
            )}
          </div>

          {/* Campos editables */}
          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="production_target" className="form-label fw-bold">
              Max. Hamburguesas <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              id="production_target"
              name="production_target"
              className={`form-control ${
                errors.production_target ? "is-invalid" : ""
              }`}
              value={formData.production_target}
              onChange={handleInputChange}
              min="0"
              placeholder="Ingrese la meta de producción"
            />
            {errors.production_target && (
              <div className="invalid-feedback">{errors.production_target}</div>
            )}
          </div>

          <div className="col-12 col-md-6 mb-3">
            <label htmlFor="delivery_target" className="form-label fw-bold">
              Max. Delivery <span className="text-danger">*</span>
            </label>
            <input
              type="number"
              id="delivery_target"
              name="delivery_target"
              className={`form-control ${
                errors.delivery_target ? "is-invalid" : ""
              }`}
              value={formData.delivery_target}
              onChange={handleInputChange}
              min="0"
              placeholder="Ingrese la meta de delivery"
            />
            {errors.delivery_target && (
              <div className="invalid-feedback">{errors.delivery_target}</div>
            )}
          </div>
        </div>

        {/* Botones de acción */}
        <div className="row mt-4">
          <div className="col-12">
            <div className="d-flex justify-content-end gap-2">
              <button type="submit" className="btn btn-success col-12">
                Guardar Cambios
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default FormEditSchedule;
